module.exports = __webpack_public_path__ + "files/9e18325bfc99f6e6fe5c72ac29c75e65.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bolditalic-webfont.svg
 ** module id = 1026
 ** module chunks = 0
 **/